import { render, staticRenderFns } from "./shopping-cart-notification.vue?vue&type=template&id=8a3ce286&scoped=true"
import script from "./shopping-cart-notification.vue?vue&type=script&lang=js"
export * from "./shopping-cart-notification.vue?vue&type=script&lang=js"
import style0 from "./shopping-cart-notification.vue?vue&type=style&index=0&id=8a3ce286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3ce286",
  null
  
)

export default component.exports